/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { TIMEFRAME_UNITS } from 'cio/utils/round-timeframe-units';
import timeframeUnits from 'cio/utils/timeframe-units';
import { EXPIRATION_UNITS } from 'cio/components/action-composer/in-app/config/expiration';

interface RelativeExpirationArgs {
  timeframeUnits: string;
  liquidExpression: string | undefined;
  seconds: number;
  selectedType: string;
  selectedLiquidUnit: string;
  onTypeChange: (selectedType: 'number' | 'liquid') => unknown;
  onExpirationChange: (seconds: number) => unknown;
  onLiquidChange: (value: number) => unknown;
  onLiquidUnitChange: (selectedLiquidUnit: 'minute' | 'hour' | 'day') => unknown;
  hasReadOnlyPermission: boolean;
}

export default class Relative extends Component<RelativeExpirationArgs> {
  readonly timeframeUnits = EXPIRATION_UNITS;

  get availableUnits() {
    let units = this.timeframeUnits;
    return TIMEFRAME_UNITS.filter((u) => units.includes(u.value));
  }

  @tracked relativeExpirationUnitOptions = timeframeUnits({
    context: this,
    units: this.availableUnits,
  });
}
